module.exports = __webpack_public_path__ + "static/media/Panorama-Beach-pano.57052daf.jpg";